const GHL_APP_BASE_URL = (process.env.VUE_APP_GHL_APP_BASE_URL || 'https://app.ai247saas.com').replace(/\/$/, '');

export function buildGhlContactUrl(locationId, contactId) {
  if (!locationId || !contactId) {
    return null;
  }
  return `${GHL_APP_BASE_URL}/v2/location/${locationId}/contacts/detail/${contactId}`;
}
